import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyDuNbayrEJnRAI-dGXgGa97r_T9VqwlkZU",
//   authDomain: "swayyourwaytours.firebaseapp.com",
//   projectId: "swayyourwaytours",
//   storageBucket: "swayyourwaytours.firebasestorage.app",
//   messagingSenderId: "831982678373",
//   appId: "1:831982678373:web:61d5e52392094f2505718c",
//   measurementId: "G-52Q80S2ZYW"
// };


const firebaseConfig = {
  apiKey: "AIzaSyDXlZ4Eu6wqPogVxfpARp8T8sjSvdUEE9g",
  authDomain: "travelscape-aae61.firebaseapp.com",
  projectId: "travelscape-aae61",
  storageBucket: "travelscape-aae61.firebasestorage.app",
  messagingSenderId: "298740727443",
  appId: "1:298740727443:web:b1c4d9807b983b09d45766",
  measurementId: "G-5FD4KXSVG6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Enable persistence properly (after initialization)
enableIndexedDbPersistence(db)
  .then(() => {
    // Persistence has been enabled successfully
  })
  .catch((error) => {
    if (error.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled in one tab at a time
    } else if (error.code === 'unimplemented') {
      // The current browser doesn't support persistence
    }
  });

// Initialize Firebase Authentication
const auth = getAuth(app);

export { db, auth };
